import { ProdutoProjection } from './../interfaces/produto-projection';
import { FatClassFiscal } from '../interfaces/fat-class-fiscal';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Produto } from '../interfaces/produto';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

import { environment } from '../../../environments/environment';
import { ProdutoMovto } from '../interfaces/produto-movto';

import { ProdutoMovtoDetails } from '../interfaces/produto-movto-details';

import { ProdutoEnums } from '../interfaces/produto-enums';

import { ProdutoClassTrib } from '../interfaces/produto-class-trib';


import { Aliquotas } from '../interfaces/aliquotas';
import { JwtAuthService } from './auth/jwt-auth.service';
import { Preco } from '../interfaces/preco';
import { CopiaPrecoItem } from '../interfaces/copia-preco-item';
import { CONNECTING } from 'ws';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {

  readonly path = '/produto';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  create(): Observable<Produto> {
    return this.http.post<Produto>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(produto: Produto): Observable<Produto> {
    return this.http.put<Produto>(`${this.jwtAuthService.apiUrl + this.path}`, produto);
  }


  getProdutoById(id: number): Observable<Produto> {
    return this.http.get<Produto>(`${this.jwtAuthService.apiUrl + this.path}/id/${id}`);
  }


  idemProduto(id: number): Observable<Produto> {
    return this.http.get<Produto>(`${this.jwtAuthService.apiUrl + this.path}/idem/${id}`);
  }

  deleteProduto(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  toogleDesativado(id: number): Observable<any> {
    return this.http.put(`${this.jwtAuthService.apiUrl + this.path}/desativar/toggle/${id}`, null);
  }


  getProdutoPage(page?: number, size?: number, order?: string,
    direction?: string, desativado?: boolean, conteudo?: boolean,
    tipo?: string): Observable<PageResult<Produto>> {
    const tipoParam = (tipo || '').toString().trim();
    return this.http.get<PageResult<Produto>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction}&desativado=${desativado ?? false}&conteudo=${conteudo ?? true}${tipoParam ? `&tipo=${encodeURIComponent(tipoParam)}` : ''}`);
  }

  getProdutoPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string,
    desativado?: boolean,
    conteudo?: boolean,
    tipo?: string,
  ): Observable<PageResult<Produto>> {
    const tipoParam = (tipo || '').toString().trim();
    return this.http.get<PageResult<Produto>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction}&desativado=${desativado ?? false}&conteudo=${conteudo ?? true}${tipoParam ? `&tipo=${encodeURIComponent(tipoParam)}` : ''}`);
  }

  /** Listagem com filtro opcional por marca/grupo (+ pesquisa). Usado na tela de Alteração de Preço. */
  getProdutoPageFiltro(page: number, size: number, search?: string, marcaId?: number, grupoId?: number): Observable<PageResult<Produto>> {
    let url = `${this.jwtAuthService.apiUrl + this.path}/page/get/v2/filtro?page=${page}&size=${size}`;
    if (search) { url += `&search=${encodeURIComponent(search)}`; }
    if (marcaId) { url += `&marcaId=${marcaId}`; }
    if (grupoId) { url += `&grupoId=${grupoId}`; }
    return this.http.get<PageResult<Produto>>(url);
  }

  getProdutoByBarcode(code: string): Observable<Produto[]> {
    return this.http.get<Produto[]>(`${this.jwtAuthService.apiUrl + this.path}/barcode/${encodeURIComponent(code)}`);
  }

  getProdutoProjectionPage(page?: number, size?: number, order?: string,
    direction?: string, desativado?: boolean, conteudo?: boolean, tipo?: string): Observable<PageResult<ProdutoProjection>> {
    const tipoParam = (tipo || '').toString().trim();
    return this.http.get<PageResult<ProdutoProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction}&desativado=${desativado ?? false}&conteudo=${conteudo ?? true}${tipoParam ? `&tipo=${encodeURIComponent(tipoParam)}` : ''}`);
  }

  getProdutoProjectionPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string,
    desativado?: boolean,
    conteudo?: boolean,
    tipo?: string,
  ): Observable<PageResult<ProdutoProjection>> {
    const tipoParam = (tipo || '').toString().trim();
    return this.http.get<PageResult<ProdutoProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction}&desativado=${desativado ?? false}&conteudo=${conteudo ?? true}${tipoParam ? `&tipo=${encodeURIComponent(tipoParam)}` : ''}`);
  }

  // ---- Endpoints Comanda ----

  getProdutoComandaPage(page?: number, size?: number, order?: string, direction?: string, desativado?: boolean, categoria?: string): Observable<PageResult<ProdutoProjection>> {
    const categoriaNormalizada = (categoria || '').toString().trim();
    const categoriaParam = categoriaNormalizada.length > 0 ? `&categoria=${encodeURIComponent(categoriaNormalizada)}` : '';

    return this.http.get<PageResult<ProdutoProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection/comanda?page=${page}&size=${size}`
      + `&order=${order ?? 'NOME'}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}${categoriaParam}`);
  }

  getProdutoComandaPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string,
    desativado?: boolean,
    categoria?: string,
  ): Observable<PageResult<ProdutoProjection>> {
    const categoriaNormalizada = (categoria || '').toString().trim();
    const categoriaParam = categoriaNormalizada.length > 0 ? `&categoria=${encodeURIComponent(categoriaNormalizada)}` : '';

    return this.http.get<PageResult<ProdutoProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection/comanda?page=${page}&size=${size}&search=${search}`
      + `&order=${order ?? 'NOME'}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}${categoriaParam}`);
  }

  getMovto(page?: number, size?: number, order?: string, direction?: string, produtoId?: string,
    dataInicial?: string, dataFinal?: string): Observable<PageResult<ProdutoMovto>> {
    return this.http.get<PageResult<ProdutoMovto>>(`${this.jwtAuthService.apiUrl + this.path}/movto/page/get/?page=${page}&size=${size}`
      + `&produtoId=${produtoId}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&order=${order}&direction=${direction}`);
  }

  getMovtoDetails(produtoId: string): Observable<ProdutoMovtoDetails> {
    return this.http.get<ProdutoMovtoDetails>(`${this.jwtAuthService.apiUrl + this.path}/movto/details?produtoId=${produtoId}`);
  }

  getEnums(): Observable<ProdutoEnums> {
    return this.http.get<ProdutoEnums>(`${this.jwtAuthService.apiUrl + this.path}/enums`);
  }

  getAliquotas(): Observable<Aliquotas> {
    return this.http.get<Aliquotas>(`${this.jwtAuthService.apiUrl + this.path}/aliquotas`);
  }

  getClassTrib(id: number): Observable<ProdutoClassTrib[]> {
    return this.http.get<ProdutoClassTrib[]>(`${this.jwtAuthService.apiUrl + this.path}/classTrib/${id}`);
  }


  saveOrUpdateClassTrib(produtoClassTrib: ProdutoClassTrib): Observable<ProdutoClassTrib> {
    return this.http.put<ProdutoClassTrib>(`${this.jwtAuthService.apiUrl + this.path}/classTrib`, produtoClassTrib);
  }

  getPrecos(produtoId: number): Observable<Preco[]> {
    return this.http.get<Preco[]>(`${this.jwtAuthService.apiUrl + this.path}/preco/${produtoId}`);
  }

  saveOrUpdatePrecos(precos: Preco[]): Observable<Preco[]> {
    const payload = (precos || []).map((preco) => ({
      ...preco,
      listaId: preco?.listaId || preco?.listaPreco?.id || 0,
      tabelaId: preco?.tabelaId || preco?.tabela?.id?.tabelaId || 0,
    }));

    return this.http.put<Preco[]>(`${this.jwtAuthService.apiUrl + this.path}/preco`, payload);
  }

  /**
   * Cópia de tabela de preço em lote (mesma lógica do desktop): grava o preço calculado
   * em vários produtos via POST /produto/preco/copia-tabela.
   */
  copiaTabelaPreco(itens: CopiaPrecoItem[]): Observable<any[]> {
    return this.http.post<any[]>(`${this.jwtAuthService.apiUrl + this.path}/preco/copia-tabela`, itens || []);
  }

  reavaliarCustoPorTransacao(payload: {
    produtoId: number;
    transacaoCodigo: number;
    custoReposicao: number;
    preco?: number;
    qtde?: number;
  }): Observable<any> {
    return this.http.post<any>(`${this.jwtAuthService.apiUrl + this.path}/reavaliacao-custo`, payload);
  }

  deleteProdutoClassTrib(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/classTrib/${id}`);
  }

  deleteProdutoPreco(id: number, lista: number, tabela: number): Observable<Preco[]> {
    return this.http.delete<Preco[]>(`${this.jwtAuthService.apiUrl + this.path}/preco/${id}/${lista}/${tabela}`);
  }

  getImageUrl(produtoId: number, index: number, base64?: boolean) {
    return `${this.jwtAuthService.apiUrl + this.path}/image/${base64 ? 'base64/' : ''}${produtoId}/${index}`;
  }


  getImage(produtoId: number, index: number): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/image/${produtoId}/${index}`, {responseType: 'arraybuffer'})
  }


  uploadImage(value: any, produtoId: number): Observable<any> {
    return this.http.post(`${this.jwtAuthService.apiUrl + this.path}/upload/${produtoId}`, value);
  }

  deleteImage(produtoId: number, index: number): Observable<any> {
    return this.http.delete(`${this.jwtAuthService.apiUrl + this.path}/image/${produtoId}/${index}`);
  }

}
